import { Component, inject } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MenuActions } from '../../shared/states/menu_actions';
import { AboutUsHeroComponent } from '@components/about-us-hero/about-us-hero.component';
import { LnFavBeigeSvgIconComponent } from '@components/svg-icons/ln-fav-beige-svg-icon/ln-fav-beige-svg-icon.component';
import { AboutUsInfoCardComponent } from '@components/cards/about-us-info-card/about-us-info-card.component';
import { VolunteerSvgIconComponent } from '@components/svg-icons/volunteer-svg-icon/volunteer-svg-icon.component';

@Component({
  selector: 'ln-about-us',
  imports: [
    LnPagesArmorComponent,
    TranslocoPipe,
    AboutUsHeroComponent,
    LnFavBeigeSvgIconComponent,
    AboutUsInfoCardComponent,
    VolunteerSvgIconComponent,
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css',
})
export class AboutUsComponent {
  private menuActions = inject(MenuActions);
  goHome() {
    this.menuActions.goHome();
  }
}
